angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "CITIES": {
    "EXPLORE_OLD": "Explore {LOCATION} with one of {COUNT, plural, one{# local} other{# locals}} who can show you around",
    "EXPLORE": "Tours with locals in {LOCATION}, with one of {COUNT, plural, other{# local}} guides"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/modules/cities/cities.json
// module id = 756
// module chunks = 12